import ArrowBottom from "assets/svg/arrow-bottom.svg";
import Link from "next/link";
import React from "react";
import { getNameAndEnumForCourseType } from "src/utils";

import styles from "./styles.module.css";
import Image from "next/image";

type Item = {
  id: number;
  idChild: number;
  title: string | null;
  link: string;
  category: null;
  categoryEnum: number;
  updateDate: string;
};

type Category = {
  categoryEnum: number;
  items: Item[];
};

enum Categories {
  inClass,
  Online,
  Offline,
  PracticalBook,
}

function Index({ data }: { data: Category[] }): JSX.Element {
  const onlineCourses = data?.find((a) => a.categoryEnum == Categories.Online);
  const offlineCourses = data?.find(
    (a) => a.categoryEnum == Categories.Offline
  );
  const inClassCourses = data?.find(
    (a) => a.categoryEnum == Categories.inClass
  );
  const practicalBookCourses = data?.find(
    (a) => a.categoryEnum == Categories.PracticalBook
  );

  const courses = [
    {
      id: 1,
      type: 1,
      title: "دوره‌های آنلاین",
      imageUrl: "/images/courses/online.png",
      color: "#0577AF",
      gradiantColorClass: styles.onlineCourse,
      linkMore: "",
      items: onlineCourses,
    },
    {
      id: 2,
      type: 0,
      title: "دوره‌های حضوری",
      imageUrl: "/images/courses/attend.png",
      color: "#4F9B0A",
      gradiantColorClass: styles.inPersonCourse,
      linkMore: "",
      items: inClassCourses,
    },
    {
      id: 3,
      type: 2,
      title: "دوره‌های آفلاین",
      imageUrl: "/images/courses/offline.png",
      linkMore: "",
      color: "#E65800",
      gradiantColorClass: styles.offlineCourse,
      items: offlineCourses,
    },
    {
      id: 4,
      type: 4,
      title: "کتب کاربردی",
      imageUrl: "/images/courses/books.png",
      color: "#77278B",
      gradiantColorClass: styles.usefulBook,
      linkMore: "http://dadbanandana.com/",
      items: practicalBookCourses,
    },
  ];

  return (
    <div className="relative z-30 -mt-6 w-full md:-mt-[110px] lg:-mt-[134px] xl:-mt-[122px]">
      <div className="relative z-10 grid w-full grid-cols-1 place-items-center justify-between gap-x-6 gap-y-5 px-[10%] text-white sm:grid-cols-2 lg:grid-cols-4">
        {courses?.map(
          (
            {
              color,
              imageUrl,
              title,
              items,
              id,
              gradiantColorClass,
              linkMore,
              type,
            },
            index: number
          ) => (
            <div
              key={id?.toString()}
              style={{
                borderColor: color,
              }}
              className="flex h-full w-full flex-col rounded-lg rounded-b-md border-b-4 bg-white shadow"
            >
              <div
                className="flex h-1/4 w-full items-center justify-between rounded-t-lg px-5 md:h-[25.5%] lg:h-[30%]"
                style={{ background: color }}
              >
                <span className="text-lg">{title}</span>
                <img
                  fetchpriority="high"
                  src={imageUrl}
                  className="z-30 mt-24 h-24 w-24"
                  alt={title}
                />
                {/*<Image*/}
                {/*  src={imageUrl}*/}
                {/*  width={200}*/}
                {/*  height={200}*/}
                {/*  className="z-30 mt-24 h-24 w-24"*/}
                {/*  alt={title}*/}
                {/*/>*/}
              </div>
              <div className="flex h-[70%] flex-col justify-between rounded-b-md bg-white pb-5">
                <div className="mt-12 grid w-full grid-cols-1 gap-y-4 leading-6 text-black-450 sm:mt-9">
                  {items?.items?.map(
                    (
                      {
                        category,
                        categoryEnum,
                        idChild,
                        link,
                        title,
                        updateDate,
                      },
                      index
                    ) => (
                      <a
                        href={link}
                        target={id == 4 ? "_blank" : "_self"}
                        key={index}
                        className={`px-5 ${gradiantColorClass}`}
                        rel="noreferrer"
                      >
                        {title}
                      </a>
                    )
                  )}
                </div>
                <div className="flex w-full justify-end">
                  <div className="flex items-center" style={{ color }}>
                    <Link
                      href={
                        id == 4
                          ? "http://dadbanandana.com/"
                          : id === 3
                          ? "/package-type/ofline/بسته-های-حقوقی-آفلاین"
                          : `/course-type/${
                              getNameAndEnumForCourseType(type)?.name
                            }`
                      }
                    >
                      <a target={id == 4 ? "_blank" : "_self"}>
                        <span
                          className="ml-2 cursor-pointer text-[17px]"
                          // onClick={() => handleClickMore(type as number)}
                        >
                          موارد بیشتر
                        </span>
                      </a>
                    </Link>
                    <ArrowBottom
                      className="rotate-90 fill-blue"
                      style={{ fill: color }}
                    />
                  </div>
                </div>
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
}

export default Index;
